import React from 'react';
import { Box, ParagraphText } from '@leagueplatform/genesis-core';

// Category tokens emitted by the masonry-scfhp BE adapter; mirrors the
// composableCard / heroBanner tag.category enum.
export type FormStatusCategory =
  | 'informational'
  | 'warning'
  | 'success'
  | 'critical'
  | 'neutral';

interface FormStatusPillProps {
  label: string;
  category: FormStatusCategory;
}

const pillBackgroundColor: Record<FormStatusCategory, string> = {
  informational: '#D9F3F3',
  warning: '#FAE8D6',
  success: '#D5F2E7',
  critical: '#F9DEE3',
  neutral: '#F0F0F0',
};

const pillDotColor: Record<FormStatusCategory, string> = {
  informational: '#00BAAE',
  warning: '#CF6902',
  success: '#00A865',
  critical: '#A12127',
  neutral: '#767676',
};

export const FormStatusPill: React.FC<FormStatusPillProps> = ({
  label,
  category,
}) => {
  const backgroundColor =
    pillBackgroundColor[category] ?? pillBackgroundColor.neutral;
  const dotColor = pillDotColor[category] ?? pillDotColor.neutral;

  return (
    <Box
      css={{
        display: 'inline-flex',
        alignItems: 'center',
        height: '24px',
        padding: '0 10px',
        gap: '6px',
        borderRadius: '99999px',
        backgroundColor,
      }}
    >
      <Box
        css={{
          width: '8px',
          height: '8px',
          backgroundColor: dotColor,
          borderRadius: '50%',
          flexShrink: 0,
        }}
      />
      <ParagraphText
        css={{
          typography: '$bodyTwo',
          fontWeight: 600,
          color: '$onSurfaceTextPrimary',
          whiteSpace: 'nowrap',
        }}
      >
        {label}
      </ParagraphText>
    </Box>
  );
};

// Hero band background tints, keyed by the same category token as the pill.
export const bandBackgroundColor: Record<FormStatusCategory, string> = {
  informational: '#D9F3F3',
  warning: '#FAE8D6',
  success: '#D5F2E7',
  critical: '#F9DEE3',
  neutral: '#F0F0F0',
};
